import * as Scrivito from "scrivito";

const RadioButtonWidget = Scrivito.provideWidgetClass("RadioButtonWidget", {
  attributes: {
    text: "string",
  },
  onlyInside: "RadioboxWidget",
});

export default RadioButtonWidget;
